import JQueryView, { on } from '../../../../../../common/views/jqueryView';

export default class ShowView extends JQueryView {
  constructor() {
    super('.edit_investor_corporate');
    this.changeRelationshipWithCorporationText();
  }

  @on({
    event: 'click',
    selector: '#beneficial_owners_comfirm_modal_close_button',
  })
  clickBeneficialOwnersComfirmModalCloseButton() {
    $('#beneficial_owners_comfirm_modal').hide();
  }

  @on({
    event: 'click',
    selector: '#beneficial_owners_comfirm_modal_add_beneficial_owners_button',
  })
  clickBeneficialOwnersComfirmModalAddBeneficialOwnersButton() {
    $('#beneficial_owners_comfirm_modal').hide();
  }

  @on({
    event: 'change',
    selector: 'input[name="investor_corporate[corporate_form]"]:radio',
  })
  changeInvestorCorporateCorporateForm() {
    this.changeRelationshipWithCorporationText();
  }

  changeRelationshipWithCorporationText() {
    const value = $(
      'input[name="investor_corporate[corporate_form]"]:checked',
    ).val();
    if (typeof value !== 'string') return;

    const text = $(`#relationship_with_corporation_text_voting_${value}`).val();
    if (typeof text !== 'string') return;

    $('select.relationship-with-corporation option[value="voting"]').html(text);
  }
}
